var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"fontsizeul"},[_c('li',[_vm._v("字号：")]),_vm._v(" "),_vm._l((_vm.fontSizeArr),function(item,index){return _c('li',{key:index,on:{"click":function($event){$event.stopPropagation();return _vm.changefontsize(item.sign)}}},[_vm._v(_vm._s(item.name))])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bfc84d44","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selectfontsize/index.vue
// module id = null
// module chunks = 